import _ from 'lodash';
import AccountConverter from 'scripts/application/dto_converters/account_converter';
import FbPagesSuccess from 'models/modal/fb_pages_success';
import OpenModal from 'actions/modal/open_modal';

export default class CreateFbAccounts {
  constructor(context) {
    this.context = context;
  }

  run({ selectedFbPageIds }) {
    let selectedAccounts = this.getSelectedAccounts(selectedFbPageIds);
    this.addAccounts(selectedAccounts);
    this.context.executeAction(OpenModal, FbPagesSuccess.create());
  }

  addAccounts(selectedAccounts) {
    _.each(selectedAccounts, account => {
      this.context.gateways.account.add(AccountConverter.toDto(account));
    });
  }

  getSelectedAccounts(selectedFbPageIds) {
    let accountStore = this.context.stores.accounts.findAll();
    return _.filter(accountStore, fbPage => _.includes(selectedFbPageIds, fbPage.content.id));
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/channels/create_fb_accounts.js